/** @jsxImportSource @emotion/react */

import { useEffect, useState, useCallback, useContext, useRef } from 'react';
import { DateField } from '@mui/x-date-pickers/DateField';
import { Button, Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, TextField, CircularProgress, Select, MenuItem, FormControl, Box } from '@mui/material';
import { CustomButton, CustomDialog, CustomSelect } from '../../components';
import { useDebouncedCallback } from 'use-debounce';
import { TransformWrapper, TransformComponent, useControls } from "react-zoom-pan-pinch";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Document, Page, pdfjs } from 'react-pdf'

import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { v4 as uuid } from "uuid";
import { DataGrid, GridActionsCellItem, gridPageSizeSelector, GridRowModes, GridToolbarContainer } from '@mui/x-data-grid';
import BackIcon from "@mui/icons-material/ArrowBack";
import ForwardIcon from "@mui/icons-material/ArrowForward";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import ResetZoomIcon from "@mui/icons-material/Restore";
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

import Grid from '@mui/material/Grid2'

import { LoginContext } from '../../context/login-context';
import InvoiceModalOptionsMenu from '../InvoiceModalOptionsMenu';
import FormElement from '../../components/form-element/form-element';
import { paddingX } from '../../emotion/utils';
import RebatesClient from '../../RebatesClient';
import { currencyFormatted } from '../../util';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();


const Controls = () => {
  const { zoomIn, zoomOut, resetTransform } = useControls();

  return (
    <Grid item >
      <IconButton onClick={() => zoomIn()}><ZoomInIcon fontSize='large' /></IconButton>
      <IconButton onClick={() => zoomOut()}><ZoomOutIcon fontSize='large' /></IconButton>
      <IconButton onClick={() => resetTransform()}><ResetZoomIcon fontSize='large' /></IconButton>

    </Grid>
  );
};



export default function InvoiceModal(props) {

  const [newStratAcctFarm, setNewStratAcctFarm] = useState({});

  const [snackbar, setSnackbar] = useState(null);
  const handleCloseSnackbar = () => setSnackbar(null);
  const [rowModesModel, setRowModesModel] = useState({});
  const [rowIdSelected, setRowIdSelected] = useState(null)
  const [rows, setRows] = useState([]);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState(null);
  const [bulkDeleteConfirm, setBulkDeleteConfirm] = useState(false);
  const [unsavedChangesConfirmId, setUnsavedChangesConfirmId] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [closeOnSave, setCloseOnSave] = useState(false)
  const [url, setUrl] = useState(null)
  const [documentBlobUrl, setDocumentBlobUrl] = useState(null)
  const noButtonRef = useRef(null);
  const bulkDeleteErrorHandledRef = useRef(false);
  const apiRef = useRef(null)
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [bulkEligibility, setBulkEligibility] = useState('');
  const [bulkIneligibleReason, setBulkIneligibleReason] = useState('');
  const [sortModel, setSortModel] = useState([{field: 'created_at', sort: 'asc'}])
  const [columnVisibility, setColumnVisibility] = useState({
    created_at: false,
    modified_at: false,
    id: false,
    invoice_row_num: false, 
    invoice_page_num: false
  })

  const { state: userData } = useContext(LoginContext);

  const {
    strategicAccounts,
    flattenStratAccounts,
    open,
    setOpen,
    invoice,
    isLoading,
    saveItem,
    deleteItem,
    bulkDeleteItems,
    isBulkDeleting,
    deleteInvoice,
    isSuccess,
    error,
    refetch,
    handleUpdateInvoiceDetails,
  } = props;

  dayjs.extend(utc);


  const parent_account_id = invoice?.account?.parent_account?.id?.parent_account?.id?.parent_account?.id || invoice?.account?.parent_account?.id?.parent_account?.id || invoice?.account?.parent_account?.id

  useEffect(() => {
    if (!open) {

      setNewStratAcctFarm({})
      setRowSelectionModel([]);
      setBulkDeleteConfirm(false);
      if (documentBlobUrl) URL.revokeObjectURL(documentBlobUrl);
      setDocumentBlobUrl(null)
      return
    }
    async function fetchDoc() {
      const resp = await RebatesClient.getUploadedDoc(invoice.id)
      const blobResp = await resp.blob()
      const blob = new Blob([blobResp], { type: invoice.fileType });
      const bloblUrl = URL.createObjectURL(blob)
      setDocumentBlobUrl(bloblUrl)
    }
    fetchDoc();

  }, [open]);

  useEffect(() => {
    setRows(invoice?.invoice_items)
  }, [invoice?.invoice_items]);


  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };


  function rowEditId(){
    return apiRef?.current?.state?.editRows?.length ? Object.keys(apiRef?.current?.state?.editRows)[0] : null
  }

const handleRowClick = useCallback((params) => {
  const hasNew = rows?.filter((row)=>row.isNew)?.length
  if(params.id == rowEditId()){
    return
  }
  else {
    const updatedRows = 
      {...(rowEditId() && { [rowEditId()]: { mode: GridRowModes.View }}),
      ...( { [params.id]: { mode: GridRowModes.Edit }})
      }

    setRowModesModel((oldModel) => ({
      ...oldModel,
      ...updatedRows

    }));
  }

    }, [rowModesModel]);

    
  useEffect(() => {
    // https://github.com/mui/mui-x/issues/8410
    if(!apiRef?.current){return}
    return apiRef.current.subscribeEvent(
      "virtualScrollerContentSizeChange",
      () => {
      
        const pageSize = gridPageSizeSelector(apiRef);
        const allRows = apiRef.current.getAllRowIds()
        const length = allRows.length
        
         //only want to scroll if the last item is a new row
         const lastRow =  apiRef.current.getRow(allRows[length-1])
         if(!lastRow?.isNew){return}

        const pagesNumber = Math.ceil(length / pageSize);
        apiRef.current.setPage(pagesNumber);
        apiRef.current.scrollToIndexes({
          rowIndex: length - 1
        });
      }
    );
  }, [apiRef.current]);
  
  const handleBulkEligibilityUpdate = async () => {
    if (!bulkEligibility || rowSelectionModel.length === 0) return;
    try {
      const response = await RebatesClient.bulkUpdateItemEligibility(
        rowSelectionModel,
        bulkEligibility,
        bulkEligibility === 'INELIGIBLE' ? bulkIneligibleReason : null
      );
      if (response.ok) {
        setRowSelectionModel([]);
        setBulkEligibility('');
        setBulkIneligibleReason('');
        refetch();
        setSnackbar({ children: 'Bulk update complete', severity: 'success' });
      } else {
        setSnackbar({ children: 'Bulk update failed', severity: 'error' });
      }
    } catch (error) {
      console.error('Bulk update failed:', error);
      setSnackbar({ children: 'Bulk update failed', severity: 'error' });
    }
  };

  const clearDeletedRowEditState = useCallback((ids) => {
    ids.forEach((id) => {
      if (apiRef.current?.getRowMode?.(id) === GridRowModes.Edit) {
        apiRef.current.stopRowEditMode({
          id,
          ignoreModifications: true,
        });
      }
    });

    setRowModesModel((oldModel) => {
      const next = { ...oldModel };
      ids.forEach((id) => delete next[id]);
      return next;
    });
  }, []);

  const processBulkDelete = useCallback(async () => {
    const selectedIds = [...rowSelectionModel];
    if (selectedIds.length === 0) {
      setBulkDeleteConfirm(false);
      return;
    }

    setBulkDeleteConfirm(false);

    const newRowIds = selectedIds.filter((id) => rows?.find((row) => row.id === id)?.isNew);
    const persistedIds = selectedIds.filter((id) => !newRowIds.includes(id));

    if (newRowIds.length > 0) {
      clearDeletedRowEditState(newRowIds);
      setRows((prev) => prev.filter((row) => !newRowIds.includes(row.id)));
    }

    if (persistedIds.length === 0) {
      setRowSelectionModel([]);
      setSnackbar({
        children: `${selectedIds.length} item${selectedIds.length > 1 ? 's' : ''} deleted`,
        severity: 'success',
      });
      return;
    }

    try {
      const result = await bulkDeleteItems(persistedIds);
      const deletedIds = result?.deleted || [];
      const failed = result?.failed || [];

      clearDeletedRowEditState(deletedIds);
      setRows((prev) => prev.filter((row) => !deletedIds.includes(row.id) && !newRowIds.includes(row.id)));
      setRowSelectionModel(failed.map((entry) => entry.id));

      const totalDeleted = deletedIds.length + newRowIds.length;
      if (failed.length === 0) {
        setSnackbar({
          children: `${totalDeleted} item${totalDeleted > 1 ? 's' : ''} deleted successfully`,
          severity: 'success',
        });
      } else if (deletedIds.length > 0 || newRowIds.length > 0) {
        const failedSummary = failed.map((entry) => `${entry.id}: ${entry.reason}`).join('; ');
        setSnackbar({
          children: `${totalDeleted} deleted, ${failed.length} failed (${failedSummary})`,
          severity: 'warning',
        });
      } else {
        setSnackbar({
          children: `Delete failed for all selected items (${failed.map((entry) => entry.reason).join('; ')})`,
          severity: 'error',
        });
      }
    } catch (error) {
      console.error('Bulk delete failed:', error);
      bulkDeleteErrorHandledRef.current = true;
      setSnackbar({ children: 'Bulk delete failed', severity: 'error' });
    }
  }, [bulkDeleteItems, clearDeletedRowEditState, rowSelectionModel, rows]);

  function EditToolbar(props) {
    const { setRows, setRowModesModel } = props;

    const handleClick = () => {
    const hasNew = rows?.filter((row)=>row.isNew)?.length
    if(rowEditId()){return}
    if(hasNew){return}
      const id = uuid();

      setRows((oldRows) => [
        ...oldRows,
        { id, part: 'New', isNew: true, created_at: new Date() },
      ]);

      const updatedRows = 
      {...(rowEditId() && { [rowEditId()]: { mode: GridRowModes.View }}),
       ...{[id]: { mode: GridRowModes.Edit }}
      }

    setRowModesModel((oldModel) => ({
      ...oldModel,
      ...updatedRows

    }));
    };


    return userData?.isValmontUser ?(
      <GridToolbarContainer sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CustomButton
          label="+ Add Record"
          onClick={handleClick}
        />
        {rowSelectionModel.length > 0 && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 2 }}>
            <span style={{ fontSize: 14, fontWeight: 500 }}>
              {rowSelectionModel.length} item{rowSelectionModel.length > 1 ? 's' : ''} selected
            </span>
            <FormControl size="small" sx={{ minWidth: 140 }}>
              <Select
                value={bulkEligibility}
                onChange={(e) => {
                  setBulkEligibility(e.target.value);
                  if (e.target.value === 'ELIGIBLE') setBulkIneligibleReason('');
                }}
                displayEmpty
                sx={{ fontSize: 14, height: 32 }}
              >
                <MenuItem value="" disabled>Set Eligibility</MenuItem>
                <MenuItem value="ELIGIBLE">Eligible</MenuItem>
                <MenuItem value="INELIGIBLE">Ineligible</MenuItem>
              </Select>
            </FormControl>
            {bulkEligibility === 'INELIGIBLE' && (
              <FormControl size="small" sx={{ minWidth: 200 }}>
                <Select
                  value={bulkIneligibleReason}
                  onChange={(e) => setBulkIneligibleReason(e.target.value)}
                  displayEmpty
                  sx={{ fontSize: 14, height: 32 }}
                >
                  <MenuItem value="" disabled>Select Reason</MenuItem>
                  <MenuItem value="NON_VALLEY_DEALER">Not Purchased from Valley Dealer</MenuItem>
                  <MenuItem value="NON_QUALIFIYING_PART">Non-Qualifying Part</MenuItem>
                  <MenuItem value="COMPETITOR">Competitor</MenuItem>
                </Select>
              </FormControl>
            )}
            <Button
              variant="contained"
              size="small"
              disabled={!bulkEligibility || (bulkEligibility === 'INELIGIBLE' && !bulkIneligibleReason)}
              onClick={handleBulkEligibilityUpdate}
              sx={{ textTransform: 'none', fontSize: 14, height: 32 }}
            >
              Apply
            </Button>
            <Button
              variant="outlined"
              color="error"
              size="small"
              disabled={isBulkDeleting}
              onClick={() => setBulkDeleteConfirm(true)}
              sx={{ textTransform: 'none', fontSize: 14, height: 32 }}
            >
              Delete Selected
            </Button>
          </Box>
        )}
      </GridToolbarContainer>
    ):null;
  }

  useEffect(() => {
    if (error) {
      if (bulkDeleteErrorHandledRef.current) {
        bulkDeleteErrorHandledRef.current = false;
        return;
      }
    console.log(error)
      setDeleteConfirm(false)
      setSnackbar({ children: 'Error updating invoice', severity: 'error' });
    }
  }, [error]);

  useEffect(() => {
    if (isSuccess) {
      setDeleteConfirm(false)
      setSnackbar({ children: 'Save complete', severity: 'success' });
      
      if(closeOnSave) {
        setOpen(null)
        setCloseOnSave(false)
      }
    }

  }, [isSuccess]);



  const processRowUpdate = useCallback(
    async (newRow) => {
      const updatedRow = { ...newRow, invoiceId: invoice?.id }
      saveItem(updatedRow)
      return updatedRow
    },
    [saveItem, invoice?.id],
  );



  const processInvoiceDelete = useCallback( async () => {
     await deleteInvoice(invoice?.id)
     setOpen(false)
},[invoice]);

  const processRowDelete = useCallback(() => {
    const idToDelete = deleteRowId;
    if (!idToDelete) {
      setDeleteConfirm(false);
      return;
    }

    const row = rows?.find((r) => r.id === idToDelete);

    setDeleteConfirm(false);
    setDeleteRowId(null);

    clearDeletedRowEditState([idToDelete]);

    setRows((prev) => prev.filter((r) => r.id !== idToDelete));

    if (row && !row.isNew) {
      deleteItem(idToDelete);
    }
  }, [clearDeletedRowEditState, deleteItem, rows, deleteRowId]);




  const debounceInvoiceDetailsChange = useDebouncedCallback(

    (invoice) => {
      const details =  {
        invoice_memo:invoice?.invoice_memo, 
        invoice_date:invoice?.invoice_date, 
        invoice_number:invoice?.invoice_number, 
        invoice_id: invoice.id,
        account_id: invoice?.account_id,
        dealer: invoice?.dealer
      }

      handleUpdateInvoiceDetails(details)
    },
    1000
  );


  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const renderConfirmDeleteDialog = () => {

    if (!deleteConfirm) {
      return null;
    }
    return (
      <Dialog
        maxWidth="xs"
        // TransitionProps={{ onEntered: handleEntered }}
        open={true}
      >
        <DialogTitle>Are you sure you want to delete this row?</DialogTitle>
        <DialogContent dividers>
        </DialogContent>
        <DialogActions>
          <Button ref={noButtonRef}
            onClick={() => {
              setDeleteConfirm(false);
              setDeleteRowId(null);
            }}
          >
            No
          </Button>
          <Button

            onClick={() => processRowDelete()}
          >Yes</Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderBulkDeleteConfirmDialog = () => {
    if (!bulkDeleteConfirm) {
      return null;
    }

    const selectedCount = rowSelectionModel.length;

    return (
      <Dialog maxWidth="xs" open={true}>
        <DialogTitle>
          Are you sure you want to delete {selectedCount} selected item{selectedCount > 1 ? 's' : ''}?
        </DialogTitle>
        <DialogContent dividers />
        <DialogActions>
          <Button onClick={() => setBulkDeleteConfirm(false)} disabled={isBulkDeleting}>No</Button>
          <Button color="error" disabled={isBulkDeleting} onClick={() => processBulkDelete()}>Yes</Button>
        </DialogActions>
      </Dialog>
    );
  };



  const columns = [
    { field: 'created_at', headerName: 'Created At', width: 190, type:'dateTime', valueGetter: (value) => value && new Date(value), },
   
    { field: 'modified_at', headerName: 'Modifed At', width: 190, type:'dateTime', valueGetter: (value) => value && new Date(value), },
   
    { field: 'id', headerName: 'id', width: 90},
    { field: 'invoice_row_num', headerName: 'Inv Row#', width: 10},
    { field: 'invoice_page_num', headerName: 'Inv Page#', width: 10},
    {
      field: 'part',
      headerName: 'Part Name',
      width: 140,
      editable: true,
      type: 'text',
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 220,
      editable: true,
      type: 'text',
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      width: 100,
      editable: true,
      type: 'number',
    },
    {
      field: 'retail_price',
      headerName: 'Retail Price',
      width: 100,
      editable: true,
      type: 'currency',
      valueFormatter: (value) => {
        return currencyFormatted(value)
      }
    },
    {
      // field: 'ext_price',
      headerName: 'Ext Price',
      width: 100,
      editable: false,
      type: 'currency',
      valueGetter: (_, row) => {
        return row?.quantity * row?.retail_price
      },
      valueFormatter: (value) => {
        return currencyFormatted(value)
      }
    },
    {
      field: 'eligibility',
      headerName: 'Item Eligibility',
      width: 120,
      editable: true,

      type: 'singleSelect',

      valueOptions: [
        { value: "ELIGIBLE", label: "Eligible" },
        { value: "INELIGIBLE", label: "Ineligible" }
      ],
      valueGetter: (_, row) => {  
        return row.eligibility 
      },

    },
    {
      field: 'ineligible_reason',
      headerName: 'Ineligible Reason',
      width: 140,
      editable: true,

      type: 'singleSelect',

      valueOptions: ({row}) => {
         //note I tried to make this column conditionally editiable but that doesn't work with select dropdowns, 
         // so instead making the select array empty if eligable is picked. Also have to get state from apiRef because row is not updated


        const eligibility = apiRef.current.getRowWithUpdatedValues(row?.id).eligibility
    
        return eligibility === 'INELIGIBLE' ? [
          { value: "NON_VALLEY_DEALER", label: "Not Purchased from Valley Dealer" },
          { value: "NON_QUALIFIYING_PART", label: "Non-Qualifying Part" },
          { value: "COMPETITOR", label: "Competitor" }
        ] : []
      } ,
      valueGetter: (_, row) => {  
        // //If valley has marked something as “Competitor” the Strategic Account and Farm will see it as “Ineligible”. They don’t want customers to know they are farming competitor data. 
        // (userData.user_role == "FARM" || userData.user_role == "STRATEGIC_ACCOUNT") && row.eligibility == "COMPETITOR" ? 'NON_QUALIFIYING_PART' : 
        return row?.ineligible_reason || ''
      },


      preProcessEditCellProps: (params) => {
        if(params.otherFieldsProps.eligibility.value === "INELIGIBLE" && !params.props.value?.length){
           params.props.value ="NON_QUALIFIYING_PART"
        }
        else {
          params.props.value = ""
        }
        return { ...params.props };
      },
   
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: '',
      width: 50,
      editable: false,
      cellClassName: 'actions',

      
      getActions: ({ id }) => {
        const isSelected = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isSelected) {
          return [
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={() => {
                setDeleteRowId(id);
                setDeleteConfirm(true);
              }}
              color="inherit"
            />]
        }


        else return []
      },

    }
  ]
  

  const checkUnsavedChangesAndClose = useCallback(() => {
    //unsaved new recorsd have isNew in the array, but edited exisitng records will be stored in array. 
    //most cases isNew records won't appear as they get auto saved

    const id = rows?.filter((row)=>row.isNew)[0]?.id || rowEditId()
  
    if(id) {
      apiRef.current.stopRowEditMode({
        id: id,
        ignoreModifications: false
      });
      setCloseOnSave(true)
    }
    else {
      setOpen(false)
    }



  }, [rows])



  const handleProcessRowUpdateError = useCallback((error) => {
    setSnackbar({ children: error.message, severity: 'error' });
  }, []);


  //Strategic, Farm Account, Dealer or  should only see data if it’s in “approved” or “paid”
  const showGrid = userData?.isValmontUser || (invoice?.status == 'APPROVED' || invoice?.status == 'PAID')

  function getTotal(onlyEligible) {
    const amt = invoice?.invoice_items?.reduce(function (acc, item) { return acc + (((onlyEligible && item?.eligibility == "ELIGIBLE") ||!onlyEligible) ? (item.quantity * item.retail_price) : 0) }, 0)
    return amt
  }
  return (
    <CustomDialog
      flexDirection="column"
      open={open}
      // onClose={() =>  setOpen(null)}
      onClose={checkUnsavedChangesAndClose}
      title={"Invoice"}
      dialogCss={css.dialog}
      width={'90%'}
      // height={"900"}
    >

      {/* <Box sx={{ flexGrow: 1 }}> */}
      
        <div css={css.container}>
          {/* <Grid item xs={5}> */}
            {userData?.isValmontUser && <InvoiceModalOptionsMenu options={[{key:'Delete Invoice', action:processInvoiceDelete }]}></InvoiceModalOptionsMenu>}
          

          <div css={css.viewer}>

          {!documentBlobUrl &&

            <div style={{  width: '100%', height: '100%', display: 'grid', alignContent: 'center', justifyContent: 'center' }} >

              <CircularProgress />
              <div>Loading...</div>

            </div>

          }
          {documentBlobUrl &&
            <TransformWrapper>
              <TransformComponent>
                {documentBlobUrl &&
                  <div style={{ cursor: 'grab' }}>

                    {invoice.fileType == 'application/pdf' ? (
                      <Document

                        file={documentBlobUrl}


                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={(e) => console.log(e)}
                      >

                        <Page
                          renderAnnotationLayer={false}
                          renderTextLayer={false}
                          pageNumber={pageNumber}
                          width={'650'}
                        />
                      </Document>) :

                      <img
                        style={{ maxWidth: "100%", borderRadius: "20px" }}
                        src={documentBlobUrl}>
                      </img>



                    }
                  </div>
                }

              </TransformComponent>


              {
                <Grid container justifyContent="space-between" >
                  <Grid item alignContent={'center'} >
                    {numPages > 0 &&
                      <>
                        <IconButton onClick={(e) => setPageNumber(pageNumber - (pageNumber == 1 ? 0 : 1))}>
                          <BackIcon />
                        </IconButton>
                        Page {pageNumber} of {numPages}

                        <IconButton onClick={(e) => setPageNumber(pageNumber + (pageNumber < numPages ? 1 : 0))}>
                          <ForwardIcon />

                        </IconButton>
                      </>
                    }
                  </Grid>

                  <Controls></Controls>

                </Grid>

              }
            </TransformWrapper>
          }
          {/* </Grid> */}
          </div>

          <div css={css.info}>

            {userData?.isValmontUser && (
              <div css={css.reviewPills}>
                <span
                  css={[css.reviewPill, css.reviewPillClickable, invoice?.is_aftermarket_part_review ? css.aftermarketReviewed : css.aftermarketPending]}
                  onClick={() => handleUpdateInvoiceDetails({
                    invoice_id: invoice.id,
                    is_aftermarket_part_review: !invoice?.is_aftermarket_part_review,
                  })}
                >
                  {invoice?.is_aftermarket_part_review
                    ? <CheckCircleOutlinedIcon css={css.reviewPillIcon} />
                    : <span css={css.reviewPillIconWrap}>
                        <RadioButtonUncheckedIcon className="icon-default" css={[css.reviewPillIcon, css.iconDefault]} />
                        <CheckCircleOutlinedIcon className="icon-hover" css={[css.reviewPillIcon, css.iconHover]} />
                      </span>
                  }
                  Aftermarket Reviewed
                </span>
                <span
                  css={[css.reviewPill, css.reviewPillClickable, invoice?.is_machine_part_review ? css.machineReviewed : css.machinePending]}
                  onClick={() => handleUpdateInvoiceDetails({
                    invoice_id: invoice.id,
                    is_machine_part_review: !invoice?.is_machine_part_review,
                  })}
                >
                  {invoice?.is_machine_part_review
                    ? <CheckCircleOutlinedIcon css={css.reviewPillIcon} />
                    : <span css={css.reviewPillIconWrap}>
                        <RadioButtonUncheckedIcon className="icon-default" css={[css.reviewPillIcon, css.iconDefault]} />
                        <CheckCircleOutlinedIcon className="icon-hover" css={[css.reviewPillIcon, css.iconHover]} />
                      </span>
                  }
                  Machine Reviewed
                </span>
              </div>
            )}
            
            <FormElement label="Parent Entity" width={48}>
              <CustomSelect
                readOnly={!userData?.isValmontUser}
                disabled={!userData?.isValmontUser}
                value={newStratAcctFarm?.acct_id || parent_account_id}
                options={flattenStratAccounts()}
                onChange={(e)=>{setNewStratAcctFarm({acct_id: e.target.value, farm_account_id:-1})}}
              >
                
              </CustomSelect>
            </FormElement>
            
            <FormElement label="Sub Account" width={48}>
            <CustomSelect
                readOnly={!userData?.isValmontUser}
                disabled={!userData?.isValmontUser}
                selectedColor={newStratAcctFarm?.farm_account_id == -1 ? 'red' : null}
                value={newStratAcctFarm?.farm_account_id || invoice?.account_id}
                defaultValue={{ id: -1}}
                options={
                 [ {value:-1, name: "Select Farm", id: -1, disabled:true},  
                  ...flattenStratAccounts()?.find(sa=>(newStratAcctFarm?.acct_id ? (sa.id === newStratAcctFarm?.acct_id ) : sa.id === parent_account_id))?.children_accounts?.filter(acct=>acct.account_type == "FARM") || []] 
                }
                onChange={(e)=>{setNewStratAcctFarm({...newStratAcctFarm, farm_account_id:e.target.value});debounceInvoiceDetailsChange({ ...invoice, account_id: e.target.value })}}
              >
              </CustomSelect>
            </FormElement>

            <FormElement label="Invoice Number" width={48}>
              <TextField
                readOnly={!userData?.isValmontUser}
                disabled={!userData?.isValmontUser}
                id={"invoice_number"}
                defaultValue={invoice?.invoice_number}
                onChange={(event) => {
                  // console.log(event);
                  debounceInvoiceDetailsChange({ ...invoice, invoice_number: event.target.value })
                }}
              />
            </FormElement>
            
            <FormElement label="Invoice Date" width={48}>
              <DateField readOnly={!userData?.isValmontUser} id={"invoice_date"} defaultValue={dayjs.utc(invoice?.invoice_date)}
                onChange={(date) => {
                  console.log(date);
                  if (date && date?.isValid()) {
                    debounceInvoiceDetailsChange({ ...invoice, invoice_date: new Date(date) })
                  }
                }
                }
              />
            </FormElement>
              
            <FormElement label="Invoice Total" width={48}>
              <TextField
                readOnly={true}
                disabled={true}
                id={"invoice_total"}
                defaultValue={`${currencyFormatted(getTotal(false))}`}
              />
            </FormElement>
            
            <FormElement label="Eligible Invoice Total" width={48}>
              <TextField
                readOnly={true}
                disabled={true}
                id={"eligible_invoice_total"}
                defaultValue={`${currencyFormatted(getTotal(true))}`}
              />
            </FormElement>

            <FormElement label={`Rebate %`} width={48}>
              <TextField
                readOnly={true}
                disabled={true}
                id={"rebate_percent"}
                defaultValue={`${invoice?.rebate_amt*100}%`}
              />
            </FormElement>

            <FormElement label={`Total Rebate`} width={48}>
              <TextField
                readOnly={true}
                disabled={true}
                id={"rebate_amt"}
                //todo use value instead, this is causing data not to update after user saves
                defaultValue={`${(currencyFormatted(getTotal(true)*invoice?.rebate_amt))}`}
              />
            </FormElement>
            
            <FormElement label="Memo" width={48}>
              <TextField
                readOnly={!userData?.isValmontUser}
                disabled={!userData?.isValmontUser}
                fullWidth
                id={"invoice_memo"}
                defaultValue={invoice?.invoice_memo}
                onChange={(event) => {
                  debounceInvoiceDetailsChange({ ...invoice, invoice_memo: event.target.value })
                }}
              />
            </FormElement>

            <FormElement label="Dealer" width={48}>
              <TextField
                readOnly={!userData?.isValmontUser}
                disabled={!userData?.isValmontUser}
                fullWidth
                id={"dealer"}
                defaultValue={invoice?.dealer}
                onChange={(event) => {
                  debounceInvoiceDetailsChange({ ...invoice, dealer: event.target.value })
                }}
              />
            </FormElement>

            {showGrid &&

              <div id="table">
                {/* {renderUnsavedChangesDialog()} */}
                {renderConfirmDeleteDialog()}
                {renderBulkDeleteConfirmDialog()}

                <DataGrid
                  onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                  onColumnVisibilityModelChange={(newVisibility) => setColumnVisibility(newVisibility)}
                  columnVisibilityModel={columnVisibility}
                  sortModel={sortModel}
                  apiRef={apiRef}
                  editMode='row'
                  rowModesModel={rowModesModel}
                  onRowModesModelChange={handleRowModesModelChange}
                  slots={{
                    toolbar: EditToolbar,
                  }}
                  loading={isLoading}
                  slotProps={{
                    toolbar: { setRows, setRowModesModel },
                    loadingOverlay: {
                      variant: 'linear-progress',
                      noRowsVariant: 'skeleton',
                    },
                  }}

                  checkboxSelection={!!userData?.isValmontUser}
                  rowSelectionModel={rowSelectionModel}
                  onRowSelectionModelChange={(newSelection) => setRowSelectionModel(newSelection)}
                  isRowSelectable={(params) => {
                    return !!userData?.isValmontUser && !params.row?.isNew
                  }}

                  isCellEditable={(params) => {    
                    if (!userData?.isValmontUser) { return false }
                    return true
                  }}

                  rows={rows}
                  sx={{
                    ".MuiDataGrid-row--editing .MuiDataGrid-cell": {
                      bgcolor: "#ffbdbd",
                    },
                  }}
                  onRowClick={handleRowClick}
                  columns={columns}
                  processRowUpdate={processRowUpdate}
                  onProcessRowUpdateError={handleProcessRowUpdateError}
                />
              </div>
            }
          </div>



        </div>


        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )
        }
      {/* </Box> */}
    </CustomDialog>
  );
}

const css = {
  dialog: {
    height: '100%',
    overflow: 'hidden',
  },

  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: 24,
    width: '100%',

    '@media screen and (min-width: 992px)': {
      flexFlow: 'row nowrap',
      justifyContent: 'space-between',
    },
  },

  viewer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    height: '100%',
    maxHeight: '50%',
    width: '100%',
    
    '@media screen and (min-width: 992px)': {
      maxHeight: 'unset',
      width: '40%',
    },

    '> div:first-of-type': {
      border: '1px solid #EAECF0',
      borderRadius: 12,
      overflow: 'hidden',
      height: 'auto',
      width: '100%',
      
      '@media screen and (min-width: 992px)': {
        flex: 1,
      }
    },
  },

  info: {
    // height: '100%',
    maxHeight: '100%',
    overflowY: 'scroll',
    width: '100%',

    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: 16,

    '@media screen and (min-width: 992px)': {
      ...paddingX(24),
      width: 'calc(60% - 24px)',
    },

    '> div': {
      minWidth: '100%',

      '@media screen and (min-width: 576px)': {
        minWidth: 'unset',
      },
    }
  },

  reviewPills: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    gap: 8,
    width: '100%',
  },

  reviewPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 12px 4px 8px',
    borderRadius: 16,
    fontFamily: 'Inter, sans-serif',
    fontSize: 13,
    fontWeight: 500,
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    transition: 'color 0.15s, background-color 0.15s',
  },

  reviewPillClickable: {
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      opacity: 0.85,
    },
    '&:hover .icon-default': {
      opacity: 0,
    },
    '&:hover .icon-hover': {
      opacity: 1,
    },
  },

  reviewPillIconWrap: {
    display: 'inline-flex',
    alignItems: 'center',
    position: 'relative',
    width: 16,
    height: 16,
  },

  reviewPillIcon: {
    fontSize: '16px !important',
  },

  iconDefault: {
    position: 'absolute',
    transition: 'opacity 0.15s',
  },

  iconHover: {
    position: 'absolute',
    opacity: 0,
    transition: 'opacity 0.15s',
  },

  aftermarketReviewed: {
    backgroundColor: '#EBF3FA',
    color: '#3075A4',
    border: '1px solid #7CB4D6',
  },

  aftermarketPending: {
    backgroundColor: '#FFFFFF',
    color: '#667085',
    border: '1px solid #7CB4D6',
    '&:hover': {
      color: '#3075A4',
      backgroundColor: '#F5F9FC',
      '& .icon-default': { opacity: 0 },
      '& .icon-hover': { opacity: 1 },
    },
  },

  machineReviewed: {
    backgroundColor: '#FDF4EB',
    color: '#B8560F',
    border: '1px solid #E8B880',
  },

  machinePending: {
    backgroundColor: '#FFFFFF',
    color: '#667085',
    border: '1px solid #E8B880',
    '&:hover': {
      color: '#B8560F',
      backgroundColor: '#FEF9F4',
      '& .icon-default': { opacity: 0 },
      '& .icon-hover': { opacity: 1 },
    },
  },
};

